

import { GetTrialsByUserAndInstitutionId, GetTrialsByUserAndInstitutionIdResponse } from '@/api/dtos';
import AuthenticatedUserContext from '@/contexts/authentication/AuthenticatedUserContext';
import { useContext, useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../api/useGet';

const getData = (response?: SWRResponse<GetTrialsByUserAndInstitutionIdResponse, GetTrialsByUserAndInstitutionIdResponse>) => response?.data?.trials;
const getError = (response?: SWRResponse<GetTrialsByUserAndInstitutionIdResponse, GetTrialsByUserAndInstitutionIdResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useTrialsByUserAndInstitutionId = (institutionId?: number, configuration?: SWRConfiguration | undefined) => {
    const { isBctStaff, isAdmin, isMedicalReviewer, isCentralScientist } = useContext(AuthenticatedUserContext);

    const request = useMemo(() => {
        if (!institutionId && !isBctStaff && !isAdmin && !isMedicalReviewer && !isCentralScientist) {
            return undefined
        }

        return () => {
            return new GetTrialsByUserAndInstitutionId({ institutionId });
        }
    }, [institutionId, isBctStaff, isAdmin, isMedicalReviewer, isCentralScientist]);

    return useGet(request, { getData, getError }, configuration);
}

export default useTrialsByUserAndInstitutionId;